throw new Error('Not a pure JavaScript implementation.');
